// VCreateEvent.tsx
import React from 'react';
import EventForm from '../../../components/EventForm';
import { CLayout } from '../../../components';
import { EventFormProvider } from '../../../context/EventFormContext';

export const VCreateEvent = (): React.ReactElement => (
    <CLayout>
        <section id="VCreateEvent">
            <EventFormProvider>
                <EventForm mode="create" />
            </EventFormProvider>
        </section>
    </CLayout>
);